// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file yatayat/network/v1/network.proto (package yatayat.network.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_yatayat_auth_v1_access } from "../../auth/v1/access_pb";
import type { LocalizedName } from "../../types/v1/types_pb";
import { file_yatayat_types_v1_types } from "../../types/v1/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yatayat/network/v1/network.proto.
 */
export const file_yatayat_network_v1_network: GenFile = /*@__PURE__*/
  fileDesc("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", [file_yatayat_auth_v1_access, file_yatayat_types_v1_types]);

/**
 * @generated from message yatayat.network.v1.Place
 */
export type Place = Message<"yatayat.network.v1.Place"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: yatayat.network.v1.PlaceKind kind = 3;
   */
  kind: PlaceKind;

  /**
   * @generated from field: yatayat.types.v1.LocalizedName name = 4;
   */
  name?: LocalizedName | undefined;

  /**
   * @generated from field: optional int32 district_id = 5;
   */
  districtId?: number | undefined;

  /**
   * @generated from field: double lat = 6;
   */
  lat: number;

  /**
   * @generated from field: double lng = 7;
   */
  lng: number;
};

/**
 * Describes the message yatayat.network.v1.Place.
 * Use `create(PlaceSchema)` to create a new message.
 */
export const PlaceSchema: GenMessage<Place> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 0);

/**
 * @generated from message yatayat.network.v1.PlaceRef
 */
export type PlaceRef = Message<"yatayat.network.v1.PlaceRef"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: yatayat.types.v1.LocalizedName name = 2;
   */
  name?: LocalizedName | undefined;
};

/**
 * Describes the message yatayat.network.v1.PlaceRef.
 * Use `create(PlaceRefSchema)` to create a new message.
 */
export const PlaceRefSchema: GenMessage<PlaceRef> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 1);

/**
 * @generated from message yatayat.network.v1.Route
 */
export type Route = Message<"yatayat.network.v1.Route"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * Issuing authority, e.g. "dotm".
   *
   * @generated from field: string authority_id = 3;
   */
  authorityId: string;

  /**
   * @generated from field: yatayat.types.v1.LocalizedName name = 4;
   */
  name?: LocalizedName | undefined;

  /**
   * @generated from field: yatayat.network.v1.PlaceRef origin = 5;
   */
  origin?: PlaceRef | undefined;

  /**
   * @generated from field: yatayat.network.v1.PlaceRef destination = 6;
   */
  destination?: PlaceRef | undefined;

  /**
   * @generated from field: bool bookable = 7;
   */
  bookable: boolean;

  /**
   * @generated from field: double distance_km = 8;
   */
  distanceKm: number;
};

/**
 * Describes the message yatayat.network.v1.Route.
 * Use `create(RouteSchema)` to create a new message.
 */
export const RouteSchema: GenMessage<Route> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 2);

/**
 * @generated from message yatayat.network.v1.RouteStop
 */
export type RouteStop = Message<"yatayat.network.v1.RouteStop"> & {
  /**
   * @generated from field: int32 seq = 1;
   */
  seq: number;

  /**
   * @generated from field: yatayat.network.v1.PlaceRef place = 2;
   */
  place?: PlaceRef | undefined;

  /**
   * @generated from field: double distance_from_origin_km = 3;
   */
  distanceFromOriginKm: number;

  /**
   * Unspecified for the first stop.
   *
   * @generated from field: yatayat.network.v1.RoadClass road_class_from_previous = 4;
   */
  roadClassFromPrevious: RoadClass;
};

/**
 * Describes the message yatayat.network.v1.RouteStop.
 * Use `create(RouteStopSchema)` to create a new message.
 */
export const RouteStopSchema: GenMessage<RouteStop> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 3);

/**
 * @generated from message yatayat.network.v1.ListPlacesRequest
 */
export type ListPlacesRequest = Message<"yatayat.network.v1.ListPlacesRequest"> & {
  /**
   * Name prefix in English (case-insensitive) or Nepali.
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * 0 means the default of 50.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message yatayat.network.v1.ListPlacesRequest.
 * Use `create(ListPlacesRequestSchema)` to create a new message.
 */
export const ListPlacesRequestSchema: GenMessage<ListPlacesRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 4);

/**
 * @generated from message yatayat.network.v1.ListPlacesResponse
 */
export type ListPlacesResponse = Message<"yatayat.network.v1.ListPlacesResponse"> & {
  /**
   * @generated from field: repeated yatayat.network.v1.Place places = 1;
   */
  places: Place[];

  /**
   * Empty on the last page.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message yatayat.network.v1.ListPlacesResponse.
 * Use `create(ListPlacesResponseSchema)` to create a new message.
 */
export const ListPlacesResponseSchema: GenMessage<ListPlacesResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 5);

/**
 * @generated from message yatayat.network.v1.ListRoutesRequest
 */
export type ListRoutesRequest = Message<"yatayat.network.v1.ListRoutesRequest"> & {
  /**
   * Only bookable (true) or only Fare Check (false) routes; unset returns both.
   *
   * @generated from field: optional bool bookable = 1;
   */
  bookable?: boolean | undefined;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message yatayat.network.v1.ListRoutesRequest.
 * Use `create(ListRoutesRequestSchema)` to create a new message.
 */
export const ListRoutesRequestSchema: GenMessage<ListRoutesRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 6);

/**
 * @generated from message yatayat.network.v1.ListRoutesResponse
 */
export type ListRoutesResponse = Message<"yatayat.network.v1.ListRoutesResponse"> & {
  /**
   * @generated from field: repeated yatayat.network.v1.Route routes = 1;
   */
  routes: Route[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message yatayat.network.v1.ListRoutesResponse.
 * Use `create(ListRoutesResponseSchema)` to create a new message.
 */
export const ListRoutesResponseSchema: GenMessage<ListRoutesResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 7);

/**
 * @generated from message yatayat.network.v1.GetRouteRequest
 */
export type GetRouteRequest = Message<"yatayat.network.v1.GetRouteRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message yatayat.network.v1.GetRouteRequest.
 * Use `create(GetRouteRequestSchema)` to create a new message.
 */
export const GetRouteRequestSchema: GenMessage<GetRouteRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 8);

/**
 * @generated from message yatayat.network.v1.GetRouteResponse
 */
export type GetRouteResponse = Message<"yatayat.network.v1.GetRouteResponse"> & {
  /**
   * @generated from field: yatayat.network.v1.Route route = 1;
   */
  route?: Route | undefined;

  /**
   * @generated from field: repeated yatayat.network.v1.RouteStop stops = 2;
   */
  stops: RouteStop[];
};

/**
 * Describes the message yatayat.network.v1.GetRouteResponse.
 * Use `create(GetRouteResponseSchema)` to create a new message.
 */
export const GetRouteResponseSchema: GenMessage<GetRouteResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_network_v1_network, 9);

/**
 * @generated from enum yatayat.network.v1.PlaceKind
 */
export enum PlaceKind {
  /**
   * @generated from enum value: PLACE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLACE_KIND_TERMINAL = 1;
   */
  TERMINAL = 1,

  /**
   * @generated from enum value: PLACE_KIND_STOP = 2;
   */
  STOP = 2,

  /**
   * @generated from enum value: PLACE_KIND_CITY = 3;
   */
  CITY = 3,
}

/**
 * Describes the enum yatayat.network.v1.PlaceKind.
 */
export const PlaceKindSchema: GenEnum<PlaceKind> = /*@__PURE__*/
  enumDesc(file_yatayat_network_v1_network, 0);

/**
 * RoadClass is the fare category of a road segment, as in DoTM fare tables.
 *
 * @generated from enum yatayat.network.v1.RoadClass
 */
export enum RoadClass {
  /**
   * @generated from enum value: ROAD_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROAD_CLASS_TERAI = 1;
   */
  TERAI = 1,

  /**
   * @generated from enum value: ROAD_CLASS_HILL = 2;
   */
  HILL = 2,

  /**
   * @generated from enum value: ROAD_CLASS_KTM_POKHARA = 3;
   */
  KTM_POKHARA = 3,
}

/**
 * Describes the enum yatayat.network.v1.RoadClass.
 */
export const RoadClassSchema: GenEnum<RoadClass> = /*@__PURE__*/
  enumDesc(file_yatayat_network_v1_network, 1);

/**
 * NetworkService serves places, routes and their stops.
 *
 * @generated from service yatayat.network.v1.NetworkService
 */
export const NetworkService: GenService<{
  /**
   * ListPlaces lists terminals, stops and cities, ordered by code.
   *
   * @generated from rpc yatayat.network.v1.NetworkService.ListPlaces
   */
  listPlaces: {
    methodKind: "unary";
    input: typeof ListPlacesRequestSchema;
    output: typeof ListPlacesResponseSchema;
  },
  /**
   * ListRoutes lists routes, ordered by code. Bookable routes are the pilot corridors.
   *
   * @generated from rpc yatayat.network.v1.NetworkService.ListRoutes
   */
  listRoutes: {
    methodKind: "unary";
    input: typeof ListRoutesRequestSchema;
    output: typeof ListRoutesResponseSchema;
  },
  /**
   * GetRoute returns a route with its ordered stops.
   *
   * @generated from rpc yatayat.network.v1.NetworkService.GetRoute
   */
  getRoute: {
    methodKind: "unary";
    input: typeof GetRouteRequestSchema;
    output: typeof GetRouteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yatayat_network_v1_network, 0);

